import React from 'react';

const PostDummy = (props) => (
    <div className="col-12 mb-4">
        <div className="post post--dummy d-flex flex-column align-items-center">
            <span className="title mt-3"></span>
            <div className="post_head mt-4">
                <span></span>
                <span></span>
            </div>
            <div className="post_content mt-3">
                {Array(35).fill(0).map((_, i) => <span key={i}></span>)}
            </div>
            <div className="post_tags text-center mt-4">
                <span></span>
                <span></span>
                <span></span>
            </div>
        </div>
    </div>
);

export default PostDummy;